import { createSelectors } from '@src/stores/create-selectors';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  // whether the MUI desktop navigation drawer is open
  open: boolean;
  actions: Actions;
};

type Actions = {
  // set open = true
  openDrawer: () => void;
  // set open = false
  closeDrawer: () => void;
  // toggle open state
  toggleDrawer: () => void;
  // explicitly set open to a value
  setOpen: (open: boolean) => void;
};

/**
 * Zustand store for the DESKTOP navigation drawer state.
 * Desktop default: open (open: true)
 */
const useDesktopNavigationStoreBase = create<State>()(
  devtools(
    (set, get) => ({
      open: true,
      actions: {
        openDrawer: () => set({ open: true }, false, 'openDrawer'),
        closeDrawer: () => set({ open: false }, false, 'closeDrawer'),
        toggleDrawer: () => set({ open: !get().open }, false, 'toggleDrawer'),
        setOpen: (open) => set({ open }, false, 'setOpen'),
      },
    }),
    { name: 'useDesktopNavigationState' },
  ),
);

export const useDesktopNavigationStore = createSelectors(
  useDesktopNavigationStoreBase,
);
